<template>
  <div class="teacher-biometric-course navigation-top-app">
    <navigation-top-app :app="app" :back="backButton">
      <template v-slot:center>
        <div id="navigation-center">
          {{ students.show ? students.title : app.strings.app.teacher.biometric.course.list.title }}
        </div>
      </template>
    </navigation-top-app>
    <div id="teacher-biometric-course-content" :class="{'with-action': course.pending.length > 0}">
      <template v-if="!students.show">
      <div class="title" v-if="course.data.id !== 'all'">
        {{ course.data.name }}
      </div>
      <div class="title" v-else>
        {{ app.strings.app.teacher.biometric.course.all_title }}
      </div>
      <div class="subtitle" v-if="course.data.id !== 'all'">
        <div>
          {{ course.data.reference }}
        </div>
      </div>
      <div class="students-counts">
      <div class="students-count total" v-on:click="showStudents(course.students, app.strings.app.teacher.biometric.course.students_total)" v-if="!loading && !course.loading">
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_total }}
          </div>
          <div>
            {{ course.students.length }}
          </div>
          <font-awesome-icon class="chevron" :icon="['fas', 'chevron-right']" />
        </div>
      </div>
      <div class="students-count total" v-else>
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_total }}
          </div>
          <div>
            <loader-dot :size="'16px'" :color_1="'rgb(255, 255, 255)'" :color_2="'rgb(255, 255, 255)'" />
          </div>
        </div>
      </div>
      <div class="students-count validated" v-on:click="showStudents(validated, app.strings.app.teacher.biometric.course.students_validated)" v-if="!loading && !course.loading">
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_validated }}
          </div>
          <div>
            {{ validated.length }}
          </div>
          <font-awesome-icon class="chevron" :icon="['fas', 'chevron-right']" />
        </div>
      </div>
      <div class="students-count validated" v-else>
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_validated }}
          </div>
          <div>
            <loader-dot :size="'16px'" :color_1="'rgb(255, 255, 255)'" :color_2="'rgb(255, 255, 255)'" />
          </div>
        </div>
      </div>
      <div class="students-count not-validated" v-on:click="showStudents(notValidated, app.strings.app.teacher.biometric.course.students_not_validated)" v-if="!loading && !course.loading">
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_not_validated }}
          </div>
          <div>
            {{ notValidated.length }}
          </div>
          <font-awesome-icon class="chevron" :icon="['fas', 'chevron-right']" />
        </div>
      </div>
      <div class="students-count not-validated" v-else>
        <div>
          <div>
            {{ app.strings.app.teacher.biometric.course.students_not_validated }}
          </div>
          <div>
            <loader-dot :size="'16px'" :color_1="'rgb(255, 255, 255)'" :color_2="'rgb(255, 255, 255)'" />
          </div>
        </div>
      </div>
      </div>
      <div id="biometric-access-data-options" v-if="!loading && !course.loading">
        <div>
          <div v-on:click="fingerprintStart()" v-if="iframe === false">
            <div>
              <img src="@/assets/images/fingerprint_icon.png" />
            </div>
            <div>
              {{ app.strings.biometric.register.register_with }}
              <div v-html="app.strings.biometric.register.fingerprint"></div>
            </div>
          </div>
        </div>
        <div>
          <div v-on:click="facerecognitionStart()" v-if="this.faceapi.loaded">
            <div>
              <img src="@/assets/images/facerecognition_icon.png" />
            </div>
            <div>
              {{ app.strings.biometric.register.register_with }}
              <div v-html="app.strings.biometric.register.facerecognition"></div>
            </div>
          </div>
          <div style="opacity: 0.5;" v-else>
            <div>
              <img src="@/assets/images/facerecognition_icon.png" />
            </div>
            <div v-if="faceapi.loading !== undefined">
              {{ app.strings.biometric.register.register_with_loading }}
              <div>
                {{ faceapi.loading.state + '/' + faceapi.loading.states }}
                <br>
                {{ faceapi.loading.percent }} %
              </div>
            </div>
          </div>
        </div>
      </div>
      </template>
      <div id="biometric-students-table" v-else>
        <div class="student" v-for="student in students.data" v-bind:key="student.student">
          <div v-on:click="openPhoto(student)">
            <div class="student-name">
              {{ student.data.first_name }} {{ student.data.last_name_1 }} {{ student.data.last_name_2 }}
              <small>{{ student.student }}</small>
            </div>
            <span class="student-state" :class="{inside: student.state === 1}">
              {{ student.state === 1 ? app.strings.app.teacher.biometric.course.state_in : app.strings.app.teacher.biometric.course.state_out }}
            </span>
            <font-awesome-icon class="chevron" :icon="['fas', 'chevron-right']" v-if="hasPhoto(student)" />
          </div>
        </div>
        <div class="students-empty" v-if="students.data.length === 0">
          {{ app.strings.app.teacher.biometric.course.students_empty }}
        </div>
      </div>
    </div>
    <div class="bottom-action" v-if="course.pending.length > 0">
      <button class="h-button w-100" v-on:click="registerPending()" v-if="!loading && !course.loading">
        {{ app.strings.app.teacher.biometric.course.send_pending }}
      </button>
      <button class="h-button w-100" v-else>
        <loader-dot :size="'16px'" :color_1="'rgb(255, 255, 255)'" :color_2="'rgb(255, 255, 255)'" />
      </button>
    </div>

    <div id="biometric-face-image" v-if="students.image !== ''" v-on:click="students.image = ''">
      <div>
        <img :src="app.url.api + '/file/read/' + students.image + '?token=' + app.token" />
      </div>
    </div>

    <div id="biometric-register-content" :style="'background: url(\'' + require('@/assets/images/background_gradient_green.png') + '\') no-repeat;'" v-if="type == 'fingerprint'">
      <div id="biometric-register-fingerprint">
        <img src="@/assets/images/fingerprint_indicator.png" />
        <div>
          {{ app.strings.biometric.register.fingerprint_lector }}
        </div>
      </div>
    </div>

    <div id="biometric-register-content" :style="'background: url(\'' + require('@/assets/images/background_gradient_blue.png') + '\') no-repeat;'" v-if="type == 'facerecognition'">
      <div id="biometric-register-facerecognition" v-if="!faceRegistering">
        <button class="face-close" v-if="!recognition" v-on:click="faceCancel()">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
        <video ref="face-video-src" autoplay playsinline muted style="pointer-events: none;"></video>
        <div class="overlay-canvas">
          <canvas ref="face-overlay" />
          <canvas ref="face-canvas" style="display: none;" />
        </div>
        <div class="overlay-top">
          <div>
            {{ app.strings.biometric.register.facerecognition_instruction }}
          </div>
        </div>
        <div class="overlay-bottom">
          <button class="h-button orange w-100" v-on:click="toggleCamera()" v-if="!cameraChange">
            <font-awesome-icon :icon="['fas', 'sync']" />
          </button>
          <button class="h-button orange w-100 disabled" v-else>
            <font-awesome-icon :icon="['fas', 'sync']" />
          </button>

          <div style="width: 20px"></div>

          <button class="h-button success w-100" v-on:click="registerFace()" v-if="faceCanBeRegistered && !faceRegistering">
            {{ app.strings.biometric.register.facerecognition_register }}
          </button>
          <button class="h-button success w-100 disabled" v-if="!faceCanBeRegistered && !faceRegistering">
            {{ app.strings.biometric.register.facerecognition_searching }}
          </button>
          <button class="h-button success w-100 disabled" v-if="faceRegistering">
            {{ app.strings.biometric.register.facerecognition_registering }}
          </button>

          <!--<div id="camera-toggle">
            <font-awesome-icon :icon="['fas', 'sync']" v-on:click="toggleCamera()" />
          </div>-->
        </div>
      </div>
      <div style="width: 100%;height: 100%;" v-else>
        <loader-dot :size="'20px'" :percentage="facePercentage" />
      </div>
    </div>
  </div>
</template>

<script>
import FaceApi from '@/modules/face-api/face-api.module'

export default {
  name: 'app-teacher-biometric-course-view',
  components: {
  },
  data () {
    return {
      loading: false,
      iframe: false,
      recognition: false,
      register: false,
      extraWindow: '',
      type: '',
      course: {
        loading: false,
        data: {
          id: 0,
          name: '...',
          reference: '...'
        },
        students: [],
        pending: []
      },
      students: {
        show: false,
        data: [],
        title: '',
        image: ''
      },
      cameras: [],
      cameraIndex: 0,
      cameraChange: false,
      cameraStream: '',
      faceapi: '',
      facePercentage: '0',
      faceCanBeRegistered: false,
      faceRegistering: false,
      faceWithBoxes: false
    }
  },
  computed: {
    validated () {
      return this.course.students.filter(student => student.state === 1);
    },
    notValidated () {
      return this.course.students.filter(student => student.state === 0);
    }
  },
  props: [
    'app'
  ],
  mounted () {
    this.course.data.id = this.$route.params.id
    this.biometricCourseReadOne()

    if (localStorage['app-teacher-course-students-pending-' + this.course.data.id]) {
      this.course.pending = JSON.parse(localStorage['app-teacher-course-students-pending-' + this.course.data.id])
    }

    document.addEventListener('message', this.reactEventListener, false)
    window.addEventListener('message', this.windowEventListener)

    this.loadFaceApi()

    this.iframe = this.$route.query.iframe === true || this.$route.query.iframe === 'true'
    this.recognition = this.$route.query.recognition == 'true'

    if (this.recognition === true) {
      this.facerecognitionStart()
    }
  },
  beforeDestroy() {
    document.removeEventListener('message', this.reactEventListener)
    window.removeEventListener('message', this.windowEventListener)
  },
  methods: {
    reactEventListener (event) {
      let message = JSON.parse(event.data)
      if (message.action === 'fingerprint') {
        let student = this.course.students.find(student => student.student === message.data.student);
        if (student) {
          this.updateStudentState(student)
        } else {
          this.$swal({
            title: this.app.strings.app.teacher.biometric.course.error.title,
            text: this.app.strings.app.teacher.biometric.course.error.content,
            icon: 'error'
          })
        }
      }
    },
    windowEventListener (event) {
      /// if (event.origin !== window.location.origin) return
      if (event.data.action === 'closenreload') {
        this.extraWindow.close()
        window.focus()
        
        if (event.data.success === true) {
          let data = event.data.data
          let student = data.student
          this.$swal({
            title: this.app.strings.app.teacher.biometric.course.success.title[data.state],
            text: this.app.strings.app.teacher.biometric.course.success.content[data.state] + student.data.first_name + ' ' + student.data.last_name_1 + ' ' + student.data.last_name_2 + ' (' + student.student + ')',
            icon: 'success'
          })
          this.biometricCourseReadOne()
        } else {
          let error = event.data.error
          this.showError(this.app.strings, error.target, error.code)
        }
      }
    },
    // The same wait the old "back" button had: not while something is running.
    backButton () {
      if (!this.loading && !this.course.loading) {
        this.goBack()
      }
    },
    goBack () {
      if (this.students.show === true) {
        this.students.show = false
      } else {
        this.$router.back()
      }
    },
    async loadFaceApi () {
      console.log('Loading face api...')
      // The face models are served by the production web, also for the
      // Android copy loaded from file://. VUE_APP_FACEAPI_URL points them to
      // another server (a local dev server, for instance).
      this.faceapi = new FaceApi(process.env.VUE_APP_FACEAPI_URL || 'https://www.auesgestion.com', false)
    },
    biometricCourseReadOne () {
      if (this.course.loading) {
        return
      }

      this.course.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.biometric.course.read.one + this.course.data.id + '?students=true',
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.course.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            if (this.course.data.id !== 'all') {
              this.course.data = response.body.data.course
              localStorage['app-teacher-course-' + this.course.data.id] = JSON.stringify(this.course.data)
            }

            this.course.students = response.body.data.students

            let students = JSON.parse(JSON.stringify(this.course.students))
            for (let i in students) {
              delete students[i].biometric
            }

            localStorage['app-teacher-course-students-' + this.course.data.id] = JSON.stringify(students)
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'biometric-course-read-one', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.course.loading = false
        // Without connection, the last copy read; there may be none yet.
        try {
          if (this.course.data.id !== 'all') {
            this.course.data = JSON.parse(localStorage['app-teacher-course-' + this.course.data.id])
          }
          this.course.students = JSON.parse(localStorage['app-teacher-course-students-' + this.course.data.id])
        } catch (e) {
          this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
        }
      })
    },
    showStudents (students, title) {
      this.students.data = students
      this.students.title = title
      this.students.show = true
    },
    hasPhoto (student) {
      return !!(student.biometric && student.biometric.image_2)
    },
    openPhoto (student) {
      if (this.hasPhoto(student)) {
        this.students.image = student.biometric.image_2
      }
    },
    notice (key) {
      let strings = this.app.strings.app.teacher.biometric.course.notices[key]
      this.$swal({
        title: strings.title,
        text: strings.content,
        icon: 'warning'
      })
    },
    fingerprintStart () {
      // Without the app's reader, or nobody to look for, the reader screen
      // would stay open with no way out.
      if (!window.ReactNativeWebView) {
        this.notice('fingerprint_no_reader')
        return
      }

      let students = []
      for (let i in this.course.students) {
        let student = this.course.students[i]
        if (student.biometric !== undefined && student.biometric !== null && student.biometric.data_1 !== '') {
          students.push({
            code: student.student,
            data: student.biometric.data_1
          })
        }
      }

      if (students.length === 0) {
        this.notice('fingerprint_no_students')
        return
      }

      this.type = 'fingerprint'

      window.ReactNativeWebView.postMessage(JSON.stringify({
        action: 'fingerprint',
        data: {
          students: students
        }
      }))
    },
    async facerecognitionStart () {
      if (this.iframe === true && this.recognition === false) {
        if (this.extraWindow !== null && this.extraWindow !== undefined && this.extraWindow !== '') {
          this.extraWindow.close()
        }
        this.extraWindow = window.open(window.location.href + '&recognition=true', '_blank')
        this.extraWindow.focus()
        return
      }

      if (!navigator.mediaDevices) {
        this.notice('camera')
        return
      }

      navigator.mediaDevices.getUserMedia({ video: true, audio: false }).then(() => {
        return navigator.mediaDevices.enumerateDevices().then((devices) => {
          this.cameras = []
          for (let i in devices) {
            let device = devices[i]
            if (device.kind === 'videoinput') {
              this.cameras.push(device)
            }
          }

          this.type = 'facerecognition'

          this.openCamera()
        })
      }).catch(() => {
        this.notice('camera')
      })
    },
    faceCancel () {
      if (this.cameraStream !== '') {
        this.cameraStream.getTracks().forEach(track => track.stop())
        this.cameraStream = ''
      }
      this.faceCanBeRegistered = false
      this.type = ''
    },
    async openCamera () {
      this.cameraChange = true

      let camera = this.cameras[this.cameraIndex]

      if (this.cameraStream !== '') {
        let tracks = this.cameraStream.getTracks()
        tracks.forEach(track => track.stop())
      }

      this.cameraStream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: camera.deviceId
        },
        audio: false
      })

      this.$refs['face-video-src'].srcObject = this.cameraStream
      this.$refs['face-video-src'].onloadedmetadata = this.onPlay

      this.cameraChange = false
    },
    async toggleCamera () {
      this.cameraIndex++
      if (this.cameraIndex > this.cameras.length - 1) {
        this.cameraIndex = 0
      }
      this.openCamera()
    },
    async onPlay () {
      // The camera was closed: nothing else to look for.
      if (this.cameraStream === '') {
        return
      }

      const videoEl = this.$refs['face-video-src']
      const canvas = this.$refs['face-overlay']

      // Esperamos a que el video Y el canvas de overlay esten montados en el DOM.
      // El evento onloadedmetadata puede disparar onPlay antes de que Vue haya
      // renderizado el <canvas ref="face-overlay">, y matchDimensions(canvas,...)
      // reventaba con "Cannot set properties of undefined (setting 'width')",
      // dejando el recuadro transparente hasta que el canvas aparecia.
      if(!videoEl || !canvas || videoEl.paused || videoEl.ended || !this.faceapi.isFaceDetectionModelLoaded() || this.cameraChange) {
        return setTimeout(() => this.onPlay())
      }

      const ts = Date.now()

      const result = await window.faceapi.detectSingleFace(videoEl, this.faceapi.getFaceDetectorOptions()).withFaceLandmarks()

      this.faceapi.updateTimeStats(Date.now() - ts)

      if (result) {
        this.faceCanBeRegistered = true

        const dims = window.faceapi.matchDimensions(canvas, videoEl, true)
        const resizedResult = window.faceapi.resizeResults(result, dims)

        if (this.faceWithBoxes) {
          window.faceapi.draw.drawDetections(canvas, resizedResult)
        }
        // faceapi.draw.drawFaceLandmarks(canvas, resizedResult)
        const faceLandmarksArray = Array.isArray(result) ? result : [result]
        faceLandmarksArray.forEach(f => {
          new window.faceapi.draw.DrawFaceLandmarks(f.landmarks, new window.faceapi.draw.DrawFaceLandmarksOptions({
            drawLines: true,
            lineWidth: 1,
            lineColor: '#FFFFFF',
            drawPoints: true,
            pointSize: 2,
            pointColor: '#FFFFFF'
          })).draw(canvas)
        })
      } else {
        this.faceCanBeRegistered = false
      }

      if (this.cameraStream !== '') {
        setTimeout(() => this.onPlay())
      }
    },
    async registerFace () {
      if (this.faceRegistering) {
        return
      }

      this.faceRegistering = true
      this.facePercentage = '0'

      let video = this.$refs['face-video-src']
      let canvas = this.$refs['face-canvas']
      canvas.width = 500
      canvas.height = 500 * (video.videoHeight/video.videoWidth)
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)

      let faceReference = canvas.toDataURL()

      this.cameraStream.getTracks()[0].stop()
      this.cameraStream = ''

      let accuracy = 0.5

      /*for (let i in this.course.students) {
        let student = this.course.students[i]
        if (student.biometric !== undefined && student.biometric !== null && student.biometric.data_2 != '') {
          let result = await this.faceapi.compareFaces(student.biometric.data_2, faceReference, accuracy)
          if (result == true) {
            this.updateStudentState(student)
            return
          }
        }
      }*/

      /*let distance = 100.0;
      let student = null;
      for (let i in this.course.students) {
        let s = this.course.students[i]
        if (s.biometric !== undefined && s.biometric !== null && s.biometric.data_2 != '') {
          let d = await this.faceapi.getFaceDistance(s.biometric.data_2, faceReference, true)
          if (d < distance) {
            distance = d
            student = s
          }
        }
        this.facePercentage = parseInt(((parseInt(i)+1) * 100)/this.course.students.length) + ''
      }

      if (distance < accuracy && student !== null) {
        this.updateStudentState(student)
        return
      }*/

      let detectionReference = await this.faceapi.getFaceDetection(faceReference)
      let distance = 100.0;
      let student = null;
      for (let i in this.course.students) {
        let s = this.course.students[i]
        if (s.biometric !== undefined && s.biometric !== null && s.biometric.data_2 != '') {
          let detection = JSON.parse(s.biometric.data_2)
          detection.descriptor = new Float32Array(Object.values(detection.descriptor))
          let d = await this.faceapi.getFaceDetectionDistance(detection, detectionReference, true)
          if (d < distance) {
            distance = d
            student = s
          }
        }
        this.facePercentage = parseInt(((parseInt(i)+1) * 100)/this.course.students.length) + ''
      }

      if (distance < accuracy && student !== null) {
        this.updateStudentState(student)
        return
      }

      this.faceRegistering = false
      this.type = ''
      
      if (this.recognition === false) {
        this.showError(this.app.strings, 'biometric-recognition', '')
      } else {
        window.opener.postMessage({
          action: 'closenreload',
          success: false,
          error: {
            target: 'biometric-recognition',
            code: ''
          }
        }, window.location.origin)
      }
    },
    updateStudentState (student) {
      if (this.loading) {
        return
      }

      this.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.biometric.student.toggle,
        {
          id: student.course_id,
          student: student.student,
          device: this.type === 'fingerprint' ? 1 : 0
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.loading = false
        this.faceRegistering = false

        this.type = ''
        if (this.cameraStream !== '') {
          this.cameraStream.getTracks()[0].stop()
          this.cameraStream = ''
        }

        if (response.status === 200) {
          if (response.body.success === true) {
            if (this.recognition === false) {
              this.$swal({
                title: this.app.strings.app.teacher.biometric.course.success.title[response.body.data.state],
                text: this.app.strings.app.teacher.biometric.course.success.content[response.body.data.state] + student.data.first_name + ' ' + student.data.last_name_1 + ' ' + student.data.last_name_2 + ' (' + student.student + ')',
                icon: 'success'
              })
              this.biometricCourseReadOne()
            } else {
              window.opener.postMessage({
                action: 'closenreload',
                success: true,
                data: {
                  student: student,
                  state: response.body.data.state
                }
              }, window.location.origin)
            }
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              let err = response.body.error.code
              if (this.recognition === false) {
                this.showError(this.app.strings, 'biometric-update', err)
              } else {
                window.opener.postMessage({
                  action: 'closenreload',
                  success: false,
                  error: {
                    target: 'biometric-update',
                    code: err
                  }
                }, window.location.origin)
              }
            }
          }
        } else {
          if (this.recognition === false) {
            this.showError(this.app.strings, 'request', 'status-' + response.status)
          } else {
            window.opener.postMessage({
              action: 'closenreload',
              success: false,
              error: {
                target: 'request',
                code: 'status-' + response.status
              }
            }, window.location.origin)
          }
        }
      }, () => {
        this.loading = false
        this.faceRegistering = false

        let students = JSON.parse(localStorage['app-teacher-course-students-' + this.course.data.id])
        for (let i in students) {
          if (student.student === students[i].student) {
            students[i].state = students[i].state === 0 ? 1 : 0
          }
        }
        localStorage['app-teacher-course-students-' + this.course.data.id] = JSON.stringify(students)

        this.course.pending.push({
          student: student.student,
          state: student.state === 0 ? 1 : 0,
          date: new Date(),
          device: this.type === 'fingerprint' ? 1 : 0
        })
        localStorage['app-teacher-course-students-pending-' + this.course.data.id] = JSON.stringify(this.course.pending)

        this.type = ''
        if (this.cameraStream !== '') {
          this.cameraStream.getTracks()[0].stop()
          this.cameraStream = ''
        }

        this.showError(this.app.strings, 'biometric-update-offline', '')
        this.biometricCourseReadOne()
      })
    },
    registerPending () {
      if (this.loading) {
        return
      }

      this.loading = true

      this.$http.post(
        this.app.url.api + this.app.endpoints.biometric.student.register.pending,
        {
          id: this.course.data.id,
          registers: JSON.stringify(this.course.pending)
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.loading = false
        if (response.status === 200) {
          if (response.body.success === true) {
            this.$swal({
              title: this.app.strings.app.teacher.biometric.course.pending.success.title,
              text: this.app.strings.app.teacher.biometric.course.pending.success.content + this.course.pending.length,
              icon: 'success'
            })

            this.course.pending = []
            localStorage['app-teacher-course-students-pending-' + this.course.data.id] = JSON.stringify(this.course.pending)

            this.biometricCourseReadOne()
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'biometric-update', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
      }, () => {
        this.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#teacher-biometric-course-content {
  padding: 72px 0 24px;
  box-sizing: border-box;
}

#teacher-biometric-course-content.with-action {
  padding-bottom: 96px;
}

#teacher-biometric-course-content .title {
  padding: 0 !important;
  font-family: 'Lexend', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.25;
  color: #1f2a37;
  overflow-wrap: break-word;
}

.subtitle {
  margin: 4px 0 14px;
  color: #2071b7;
  font-family: 'Lexend', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.students-counts {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
  margin-top: 14px;
}

.students-count > div {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 10px 14px;
  box-sizing: border-box;
  border: 1px solid #e8edf3;
  border-left: 5px solid #2071b7;
  border-radius: 16px;
  background-color: #FFFFFF;
  color: #1f2a37;
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 15px;
}

.students-count.total > div {
  border-left-color: #2071b7;
}

.students-count.validated > div {
  border-left-color: #16a34a;
}

.students-count.not-validated > div {
  border-left-color: #dc3545;
}

.students-count > div > div:nth-of-type(1) {
  flex: 1;
  min-width: 0;
}

.students-count > div > div:nth-of-type(2) {
  padding: 0 10px;
  font-weight: 700;
}

.chevron {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 12px;
}

.student {
  margin-bottom: 10px;
}

.student > div {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  box-sizing: border-box;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  background-color: #FFFFFF;
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #1f2a37;
}

.student-name {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
}

.student-name > small {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.student-state {
  flex: 0 0 auto;
  padding: 3px 10px;
  border-radius: 999px;
  background-color: rgba(100, 116, 139, 0.12);
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.student-state.inside {
  background-color: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.students-empty {
  padding: 14px;
  border-radius: 16px;
  background-color: #FFFFFF;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

#biometric-access-data-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

#biometric-access-data-options > div > div {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 92px;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 14px;
}

#biometric-access-data-options > div:nth-of-type(1) > div {
  background-color: $color-success;
}

#biometric-access-data-options > div:nth-of-type(2) > div {
  background-color: $color-info;
}

#biometric-access-data-options > div > div > div:nth-of-type(1) {
  flex: 0 0 auto;
}

#biometric-access-data-options > div > div > div > img {
  display: block;
  height: 44px;
}

#biometric-access-data-options > div > div > div:nth-of-type(2) {
  flex: 1;
  min-width: 0;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: bold;
}

#biometric-access-data-options > div > div > div:nth-of-type(2) > div {
  font-size: 16px;
  line-height: 1.2;
}

@media (min-width: 768px) {
  .students-counts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  #biometric-students-table {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
  }
}

@media (min-width: 1024px) {
  #teacher-biometric-course-content {
    padding-top: 92px;
  }
}

#biometric-face-image {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1200;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
}

#biometric-face-image > div > img {
  display: block;
  max-width: 90vw;
  max-height: 90vh;
}

#biometric-register-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: none !important;
  height: 100%;
  background-size: 100% 100% !important;
  z-index: 1200;
}

#biometric-register-fingerprint {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

#biometric-register-fingerprint > img {
  width: 90%;
  max-width: 420px;
  max-height: 55vh;
  object-fit: contain;
}

#biometric-register-fingerprint > div {
  font-size: 30px;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
  padding: 25px;
}

#biometric-register-facerecognition {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

#biometric-register-facerecognition > video {
}

#biometric-register-facerecognition > .overlay-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

#biometric-register-facerecognition > .overlay-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  padding: 25px 64px;
  box-sizing: border-box;
}

#biometric-register-facerecognition > .overlay-bottom {
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  text-align: center;
  padding: 25px;
  box-sizing: border-box;
}

.face-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 999px;
  background-color: rgba(15, 23, 42, 0.55);
  color: #FFFFFF;
  font-size: 18px;
  cursor: pointer;
}

#camera-toggle {
  display: flex;
  padding: 0 12px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  color: #FFF;
}
</style>
